import React from 'react';
import { Modal, Form, Button, Select as AntSelect } from 'antd';

const { Option } = AntSelect;

const ApplicationForm = ({ visible, onCancel, onSubmit, selectedEvent, contestants, groups, handleContestantChange, handleGroupChange }) => {
    const contestantOptions = contestants.map(contestant => ({ value: contestant._id, label: contestant.first_name + ' ' + contestant.last_name }));
    const groupOptions = groups.map(group => ({ value: group._id, label: group.group_name }));

    return (
        <Modal open={visible} onCancel={onCancel} footer={null} title="Apply for Event">
            {selectedEvent && (
                <Form onFinish={onSubmit} layout="vertical">
                    {selectedEvent.solo_bool ? (
                        <Form.Item label="Select Contestant" name="contestant" rules={[{ required: true, message: 'Please select a contestant' }]}>
                            <AntSelect placeholder="Select a contestant" onChange={handleContestantChange}>
                                {contestantOptions.map(option => (<Option key={option.value} value={option.value}>{option.label}</Option>))}
                            </AntSelect>
                        </Form.Item>
                    ) : (
                        <>
                            <Form.Item label="Select Group" name="group" rules={[{ required: true, message: 'Please select a group' }]}>
                                <AntSelect placeholder="Select a group" onChange={handleGroupChange}>
                                    {groupOptions.map(option => (<Option key={option.value} value={option.value}>{option.label}</Option>))}
                                </AntSelect>
                            </Form.Item>
                        </>
                    )}
                    <Button type="primary" htmlType="submit">Submit</Button>
                </Form>
            )}
        </Modal>
    );
};

export default ApplicationForm;  
